import {TileGroup} from './tile-group';
import {Template} from './app-template/template';
import {ObjectId} from './object.model';
import {UserId} from './user';



export type AppId = ObjectId;
export type AppType = 'picture' | 'prop-manager' | 'tenant-portal';

export type AppIdMap = { [appId: AppId]: App };

export const APP_TYPE_PICTURE: AppType = 'picture';
export const APP_TYPE_PROP_MANAGER: AppType = 'prop-manager';
export const APP_TYPE_TENANT_PORTAL: AppType = 'tenant-portal';

export class App {
  ID: AppId;
  Name: string;
  TileGroups: TileGroup[];
  Owner: UserId;
  Type: AppType;
  Image?: string; // file upload UUID
  Config?: AppConfig;


  constructor() {
  }


  static create(appRaw: string | object): App {
    let newApp = new App();
    newApp.hydrate(appRaw);
    return newApp;
  }


  hydrate(appRaw: string | object): this {
    let obj: App;

    if (typeof appRaw === 'string') {
      obj = JSON.parse(appRaw);
    } else {
      obj = JSON.parse(JSON.stringify(appRaw));
    }

    this.ID = obj.ID;
    this.Name = obj.Name;
    this.Type = obj.Type;
    this.Owner = obj.Owner;
    this.TileGroups = obj.TileGroups;
    this.Image = obj.Image;
    this.Config = obj.Config;

    return this;
  }
}

export class NewApp {
  Owner: UserId;
  Name: string;
  Image?: string; // file upload UUID
  Type: AppType;
  Config: AppConfig;
}

export interface AppConfig {
  Subtitle?: {
    Text?: string,
    Hidden?: boolean,
  },
  Location?: AppConfigLocation,
  Template?: Template;
}

export interface AppConfigLocation {
  PostalCode?: string,
}

/**
 * All the properties that are patchable
 */
export interface AppPatch {
  Name?: string;
  Image?: string;
  Config?: AppConfig;
}
